import { render, staticRenderFns } from "./DirectDebitDeposit.vue?vue&type=template&id=c36dd972"
import script from "./DirectDebitDeposit.vue?vue&type=script&lang=js"
export * from "./DirectDebitDeposit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports